import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6371c6fb")

_pushScopeId("data-v-6371c6fb")
const _hoisted_1 = { class: "datasetDetail" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_DetailCard = _resolveComponent("DetailCard")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TypeCard = _resolveComponent("TypeCard")
  const _component_MetadataCard = _resolveComponent("MetadataCard")
  const _component_LinkCard = _resolveComponent("LinkCard")
  const _component_AdvancedCard = _resolveComponent("AdvancedCard")
  const _component_TabView = _resolveComponent("TabView")
  const _component_PreparedDataset = _resolveComponent("PreparedDataset")
  const _component_QBE = _resolveComponent("QBE")
  const _component_Menu = _resolveComponent("Menu")
  const _component_WorkspaceDataPreviewDialog = _resolveComponent("WorkspaceDataPreviewDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedDataset.label), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('managers.lovsManagement.preview'),
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.sendDatasetForPreview,
          disabled: _ctx.buttonDisabled
        }, null, 8, ["label", "onClick", "disabled"]),
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.checkFormulaForParams
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_TabView, {
        class: "tabview-custom kn-tab",
        activeIndex: _ctx.activeTab,
        "onUpdate:activeIndex": _cache[9] || (_cache[9] = ($event: any) => (_ctx.activeTab = $event)),
        "data-test": "tab-view"
      }, {
        default: _withId(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.mondrianSchemasManagement.detail.title')), 1)
            ]),
            default: _withId(() => [
              _createVNode(_component_DetailCard, {
                scopeTypes: _ctx.scopeTypes,
                categoryTypes: _ctx.categoryTypes,
                selectedDataset: _ctx.selectedDataset,
                selectedDatasetVersions: _ctx.selectedDatasetVersions,
                availableTags: _ctx.availableTags,
                loading: _ctx.loading,
                onReloadVersions: _ctx.getSelectedDatasetVersions,
                onLoadingOlderVersion: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('loadingOlderVersion'))),
                onOlderVersionLoaded: _ctx.onOlderVersionLoaded,
                onTouched: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["scopeTypes", "categoryTypes", "selectedDataset", "selectedDatasetVersions", "availableTags", "loading", "onReloadVersions", "onOlderVersionLoaded"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.alert.type')), 1)
            ]),
            default: _withId(() => [
              _createVNode(_component_TypeCard, {
                selectedDataset: _ctx.selectedDataset,
                datasetTypes: _ctx.filteredDatasetTypes,
                dataSources: _ctx.dataSources,
                businessModels: _ctx.businessModels,
                scriptTypes: _ctx.scriptTypes,
                parentValid: _ctx.v$.$invalid,
                pythonEnvironments: _ctx.pythonEnvironments,
                rEnvironments: _ctx.rEnvironments,
                onFileUploaded: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedDataset.fileUploaded = true)),
                onTouched: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('touched'))),
                onQueryEdited: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showMetadataQueryInfo = true))
              }, null, 8, ["selectedDataset", "datasetTypes", "dataSources", "businessModels", "scriptTypes", "parentValid", "pythonEnvironments", "rEnvironments"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withId(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.measureDefinition.metadata')), 1)
            ]),
            default: _withId(() => [
              _createVNode(_component_MetadataCard, {
                selectedDataset: _ctx.selectedDataset,
                showMetadataQueryInfoProp: _ctx.showMetadataQueryInfo,
                onTouched: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["selectedDataset", "showMetadataQueryInfoProp"])
            ]),
            _: 1
          }),
          (_ctx.selectedDataset.dsTypeCd == 'Query')
            ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
                header: _withId(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.link')), 1)
                ]),
                default: _withId(() => [
                  _createVNode(_component_LinkCard, {
                    selectedDataset: _ctx.selectedDataset,
                    metaSourceResource: _ctx.metaSourceResource,
                    activeTab: _ctx.activeTab,
                    onAddTables: _ctx.onAddLinkedTables,
                    onRemoveTables: _ctx.onRemoveLinkedTables
                  }, null, 8, ["selectedDataset", "metaSourceResource", "activeTab", "onAddTables", "onRemoveTables"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.selectedDataset.dsTypeCd != 'Prepared')
            ? (_openBlock(), _createBlock(_component_TabPanel, { key: 1 }, {
                header: _withId(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('cron.advanced')), 1)
                ]),
                default: _withId(() => [
                  _createVNode(_component_AdvancedCard, {
                    selectedDataset: _ctx.selectedDataset,
                    transformationDataset: _ctx.transformationDataset,
                    schedulingData: _ctx.scheduling,
                    onTouched: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["selectedDataset", "transformationDataset", "schedulingData"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["activeIndex"]),
      (_ctx.selectedDataset.dsTypeCd == 'Prepared' || _ctx.isOpenInQBEVisible(_ctx.selectedDataset))
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "far fa-share-from-square",
            class: "p-button-text p-button-rounded p-button-plain advancedTransformations",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleMenu($event, _ctx.selectedDataset)))
          }))
        : _createCommentVNode("", true),
      (_ctx.selectedDataset.dsTypeCd == 'Prepared')
        ? (_openBlock(), _createBlock(_component_PreparedDataset, {
            key: 1,
            selectedDataset: _ctx.selectedDataset,
            showMonitoringDialog: _ctx.showMonitoringDialog,
            onCloseMonitoringDialog: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showMonitoringDialog = false)),
            showDataPreparation: _ctx.showDataPreparation,
            onCloseDataPreparation: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDataPreparation = false))
          }, null, 8, ["selectedDataset", "showMonitoringDialog", "showDataPreparation"]))
        : _createCommentVNode("", true),
      (_ctx.qbeVisible)
        ? (_openBlock(), _createBlock(_component_QBE, {
            key: 2,
            sourceDataset: _ctx.selectedDataset,
            onClose: _ctx.closeQbe
          }, null, 8, ["sourceDataset", "onClose"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Menu, {
        id: "optionsMenu",
        ref: "optionsMenu",
        model: _ctx.menuButtons,
        popup: true
      }, null, 8, ["model"]),
      _createVNode(_component_WorkspaceDataPreviewDialog, {
        visible: _ctx.showPreviewDialog,
        propDataset: _ctx.previewDataset,
        onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showPreviewDialog = false)),
        previewType: 'dataset',
        loadFromDatasetManagement: true
      }, null, 8, ["visible", "propDataset"])
    ])
  ], 64))
})